import { View, StyleSheet } from "react-native";
import { Text, Icon } from "react-native-paper";

import type { QuestionComponentProps } from "./types";

import { colors } from "@/lib/theme";

// Placeholder for complex types implemented in later steps:
// medication_profile, icd_codes, poc, chart, bodyDrawing, locked
export function PlaceholderQuestion({ question, value }: QuestionComponentProps) {
    // Locked questions with a resolved value display the value instead of placeholder
    if (question.type === "locked" && value) {
        return (
            <View style={styles.lockedContainer}>
                <Icon source="lock" size={18} color={colors.textTertiary} />
                <Text style={styles.lockedValue}>{value}</Text>
            </View>
        );
    }

    return (
        <View style={styles.container}>
            <Icon source="puzzle-outline" size={24} color="#999" />
            <Text style={styles.text}>
                {question.type.replace(/_/g, " ")} — available after full form seed
            </Text>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        padding: 12,
        backgroundColor: "#f0f0f0",
        borderRadius: 8
    },
    text: {
        color: "#999",
        fontStyle: "italic",
        flex: 1
    },
    lockedContainer: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        padding: 12,
        backgroundColor: colors.backgroundSecondary,
        borderRadius: 8
    },
    lockedValue: {
        color: colors.textSecondary,
        fontSize: 15,
        flex: 1
    }
});
